import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, useScroll } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/toaster";

export default function Layout() {
  const { scrollYProgress } = useScroll();
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="relative">
      <motion.div style={{ scaleX: scrollYProgress }} className="fixed top-0 left-0 right-0 h-[2px] origin-left progress-bar-grad z-[60]" />
      <Navbar />
      <main className="relative"><Outlet /></main>
      <Footer />
      <Toaster />
    </div>
  );
}
